import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=25d22f88&scoped=true&"
import script from "./Landing.vue?vue&type=script&lang=js&"
export * from "./Landing.vue?vue&type=script&lang=js&"
import style0 from "./Landing.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Landing.vue?vue&type=style&index=1&id=25d22f88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d22f88",
  null
  
)

export default component.exports